const React = require('react');
const toLower = require('mn-utils/toLower');
const trim = require('mn-utils/trim');
const isEmail = require('mn-utils/isEmail');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const onEnterProvider = require('mn-utils/onEnterProvider');
const IconButton = require('@material-ui/core/IconButton').default;
const Visibility = require('@material-ui/icons/Visibility').default;
const VisibilityOff = require('@material-ui/icons/VisibilityOff').default;
const {
  LINK_DASHBOARD,
  LINK_ADMIN,
  LINK_BLOCKED
} = require('../../../../constants/links');
const validatePassword = require('../../../../utils/validatePassword');
const withState = require('../../../../utils/withState');
const {
  Link,
  replaceLocation,
} = require('../../../../router');
const {
  login$,
  handleChangeEmail,
  account$,
  onAccount,
} = require('../../../../emitters/account');
const ButtonAccept = require('../../../dumb/Button/Accept');
const TextFieldI = require('../../../dumb/TextField/I');
const Base = require('./components/Base');


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleChangePassword = changeProvider('password');
  const handleEmailEnter = onEnterProvider(() => {
    _passwordNode && _passwordNode.focus();
  });
  let _passwordNode;

  function handlePasswordRef(node) {
    node && (_passwordNode = node);
  }


  return (state) => {
    const {
      clicked,
    } = state;
    const email = state.email || '';
    const _email = trim(email);
    const showPassword = state.showPassword || 0;
    const password = state.password || '';
    const invalidPassword = !validatePassword(password);
    const invalidEmail = !isEmail(_email);
    const disabled = invalidPassword || invalidEmail;


    function handleSubmit() {
      _passwordNode && _passwordNode.blur();
      if (state.error) {
        return;
      }
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }
      account$.signIn({
        login: toLower(_email),
        password: trim(password),
      }).then((account) => {
        if (account.blocked) {
          replaceLocation({
            path: LINK_BLOCKED + encodeURIComponent(params.email) + '/',
          });
          return;
        }
        if (onAccount(account)) {
          return;
        }

        replaceLocation({
          path: account.admin
            ? LINK_ADMIN
            : LINK_DASHBOARD,
        });
      });
    }

    const VisibilityIcon = showPassword
      ? VisibilityOff
      : Visibility;


    return (
      <Base
        title="Login"
        content={(<>
          <TextFieldI
            className="mb30"
            value={email}
            error={clicked && invalidEmail}
            label="Email"
            helperText={
              _email
                ? 'This email is not valid'
                : '​Obligatory field'
            }
            onChange={handleChangeEmail}
            onKeyPress={handleEmailEnter}
          />
          <TextFieldI
            className="mt18"
            value={password}
            error={clicked && invalidPassword}
            label="Password"
            helperText="Password must contain Latin letters, numbers and symbols"
            type={showPassword ? 'text' : 'password'}
            onChange={handleChangePassword}
            onKeyPress={onEnterProvider(handleSubmit)}
            inputRef={handlePasswordRef}
            InputProps={{
              endAdornment: (
                <IconButton
                  className="rlv sl8 mv-5*2"
                  onClick={() => {
                    setState({
                      showPassword: !showPassword,
                    });
                  }}
                >
                  <VisibilityIcon
                    className="c0C"
                  />
                </IconButton>
              ),
            }}
          />
        </>)}
        // beforeFooter={(
        //   <div className="ph25 pt15 pb35 lh18 lts0em">
        //     <Link
        //       href={LINK_FORGOT_PASSWORD}
        //       className="c5B47FF olN tdU dn f12 fw3 o70:h"
        //     >Forgot password?</Link>
        //   </div>
        // )}
        control={(
          <ButtonAccept
            disabled={clicked && disabled}
            onClick={handleSubmit}
          >Sign in</ButtonAccept>
        )}
        // additional={(<>
        //   <div className="f12 fw3 lh lts0em">
        //     Don’t have an account?
        //   </div>
        //   <div className="pl12 rlv st-2 wmin72">
        //     <Link
        //       xhref={LINK_START}
        //       href="/start"
        //       className="c5B47FF olN tdU dn f16 fw3 o70:h"
        //     >Sign up</Link>
        //   </div>
        // </>)}
      />
    );
  };
}, {
  email: login$,
});
